import React, { useState } from "react";
import { useFieldArray } from "react-hook-form";
import AdPosition from "../adPosition/AdPosition";
import "../constants/constants.css";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import Images from "../images/Images";
import Details from "../details/Details";
import PreviewPages from "../previewPages/PreviewPages";
import SpecsheetButtonWhite from "../../button/specsheetButtonWhite/SpecsheetButtonWhite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import "./Creatives.css";

export default function Fields({
  control,
  register,
  setManageCreatives,
  manageCreatives,
  positionButton,
  setPositionButton,
}) {
  const [sidebarCreativeInformation, setSidebarCreativeInformation] =
    useState(false);
  const [buttonNumber, setButtonNumber] = useState(1);
  const [overlayActive, setOverlayActive] = useState(false);
  const [deviceImage, setDeviceImage] = useState("creative0");
  let border = "";
  const [creativeNumber, setCreativeNumber] = useState(0);
  const { fields, append, remove } = useFieldArray({
    control,
    name: "creatives",
  });

  // This will show or hide the generic specsheet info sidebar
  const showSidebarGenericSpecsheetInformation = () => {
    setSidebarCreativeInformation(!sidebarCreativeInformation);
    setOverlayActive(!overlayActive);
  };

  // This is the gray overlay behind the sidebars and will deactivate the sidebars on click
  const resetOverlay = () => {
    setOverlayActive(false);
    setSidebarCreativeInformation(false);
  };

  // This button is used to switch between creatives to be shown on the screen.
  function displayCreative(e, number) {
    e.preventDefault();
    setCreativeNumber(number);
    activateDeviceType(e, number);
  }

  // This will activate the border around the displayCreative button.
  function activateDeviceType(e, target) {
    if (deviceImage !== "") {
      document
        .getElementsByClassName(deviceImage)[0]
        .classList.remove("border");
    }
    e.target.classList.add("border");
    setDeviceImage(`creative${target}`);
  }

  // Here were add new buttons to the manageCreative object which is used to show the right number of creative buttons.
  function addCreativeNumber(e) {
    e.preventDefault();
    setButtonNumber(buttonNumber + 1);
    setManageCreatives([
      ...manageCreatives,
      {
        creative: buttonNumber + 1,
        adPositions: [
          { position: positionButton + 1, positionsList: [{ title: 0 }] },
        ],
      },
    ]);
    setPositionButton(positionButton + 1);
  }

  // Here we delete the creative button from the manageCreatives object when a creative is deleted from the form.
  function removeCreativeNumber(index) {
    const copyManageCreatives = manageCreatives;
    copyManageCreatives.splice(index, 1);
    setManageCreatives(copyManageCreatives);
    setCreativeNumber(index - 1);
  }

  return (
    <div className="form-wrapper">
      <h2>Creative Specifications section</h2>
      <ul>
        {manageCreatives?.map((item, indexButton) => {
          if (indexButton === 0) {
            border = "border";
          } else {
            border = "";
          }
          return (
            <button
              className={`display-button-creative creative${indexButton} ${border}`}
              key={indexButton}
              onClick={(e) => {
                displayCreative(e, indexButton);
              }}
            >
              {`Display Creative ${indexButton + 1}`}
            </button>
          );
        })}
        {fields.map((item, index) => {
          return (
            <li key={item.id}>
              {index === creativeNumber && (
                <div className="input-container-form">
                  <button
                    className="add-button"
                    onClick={(e) => {
                      addCreativeNumber(e, index);
                      append({
                        creative: "",
                        creativeIcon: "desktop",
                        mandatory: "true",
                        mandatoryAdditionalInfo: "",
                        images: [
                          {
                            url: "",
                            website: "",
                          },
                        ],
                        details: [
                          {
                            title: "",
                            infoFields: [
                              {
                                subject: "",
                                text: "",
                                type: "text",
                                url: "",
                              },
                            ],
                          },
                        ],
                        adPositions: [
                          {
                            position: "",
                            positionsList: [
                              {
                                type: "fixedPosition",
                                title: "",
                                htmlName: "",
                                details: [
                                  {
                                    title: "",
                                    infoFields: [
                                      {
                                        subject: "",
                                        text: "",
                                        type: "text",
                                        url: "",
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                            extraInformation: "",
                          },
                        ],
                      });
                    }}
                  >
                    Add creative number
                  </button>

                  <div className="inner-input-container">
                    <div className="creative-form-container">
                      {index === creativeNumber && (
                        <div className="position-top-container-form">
                          <section className="form-wrapper-position">
                            <div className="wrapper-creative-form">
                              <div className="position-top-wrapper-form">
                                <InputFieldFormArray
                                  label={`Creative ${creativeNumber + 1} name `}
                                  fieldRef={register(
                                    `creatives[${index}].creative`,
                                    {
                                      required: false,
                                    }
                                  )}
                                  name={`creatives[${index}].creative`}
                                  type="text"
                                />
                                <p className="message">
                                  Each creative has it's own section. For
                                  example Desktop creative, Mobile creative,
                                  etc.
                                </p>
                              </div>
                              <button
                                className="creative-button delete-button"
                                type="button"
                                onClick={() => {
                                  remove(index);
                                  removeCreativeNumber(index);
                                }}
                              >
                                Delete Creative
                              </button>
                            </div>
                          </section>

                          <section className="select-wrapper device-form-wrapper">
                            <div className="label-wrapper">
                              <label>Device Icon </label>
                            </div>
                            <div>
                              <select
                                {...register(
                                  `creatives[${index}].creativeIcon`,
                                  {
                                    required: false,
                                  }
                                )}
                              >
                                <option value="desktop">Desktop</option>
                                <option value="mobile">Mobile</option>
                                <option value="tablet">Tablet</option>
                                <option value="inapp">In App</option>
                                <option value="desktopmobiletablet">
                                  Desktop / Mobile / Tablet
                                </option>
                                <option value="desktopmobile">
                                  Desktop / Mobile
                                </option>
                                <option value="desktoptablet">
                                  Desktop / Tablet
                                </option>
                              </select>
                            </div>
                          </section>
                        </div>
                      )}

                      <AdPosition
                        {...{
                          control,
                          register,
                          index,
                          setManageCreatives,
                          manageCreatives,
                          creativeNumber,
                        }}
                      />

                      <div className="generic-container-form">
                        <p className="position-title">Generic</p>
                        <SpecsheetButtonWhite
                          type="button"
                          handleClick={showSidebarGenericSpecsheetInformation}
                        >
                          Creative Information
                        </SpecsheetButtonWhite>

                        <div
                          className={
                            sidebarCreativeInformation
                              ? "creative-information-container__active"
                              : "creative-information-container"
                          }
                        >
                          <div className="slider-container">
                            <div className="container-title-slider">
                              <p className="title-slider">
                                CREATIVE INFORMATION
                              </p>

                              <FontAwesomeIcon
                                className="close-icon"
                                icon={faXmark}
                                onClick={showSidebarGenericSpecsheetInformation}
                              />
                            </div>

                            <Details
                              {...{
                                control,
                                register,
                                index,
                                showSidebarGenericSpecsheetInformation,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <PreviewPages {...{ control, register, index }} />
                    </div>

                    <Images {...{ control, register, index }} />
                  </div>
                </div>
              )}
            </li>
          );
        })}
      </ul>
      <div
        className={overlayActive ? "overlay-visible" : "overlay"}
        onClick={resetOverlay}
      ></div>
    </div>
  );
}
